import CancelableApi from "./CancelableApi";
import CancelableAxiosInstance from "./CancelableAxiosInstance";

export default class LabelApi extends CancelableApi {
  static with(axios: CancelableAxiosInstance) {
    return new LabelApi(axios);
  }

  importLabel(file: File): Promise<string> {
    return this.client.post("/label/import", file, { headers: { "Content-Type": "application/json" } }).then((resp) => {
      return resp.data;
    });
  }
}
